import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Authorization } from 'src/app/intefaces/authorization';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { HttpAlertService } from '../../services/http-alert.service';
import { CartService } from 'src/app/services/cart.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html',
  styleUrls: ['./authorization.component.scss']
})
export class AuthorizationComponent implements OnInit {
  public loginForm: FormGroup;
  public logging: boolean = false;
  @Input() redirectValidLogin: string = '/';
  @Output() loginEmitter = new EventEmitter<any>();

  constructor(
    private authService: AuthorizationService,
    private fb: FormBuilder,
    private router: Router,
    private httpAlertService: HttpAlertService,
    private cartService: CartService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.initLoginForm();
  }

  public onLogIn() {
    if (this.loginForm.valid) {
      this.login();
    }
  }

  private login() {
    this.logging = true;
    this.authService.login(this.loginForm.value).subscribe(data => {
      let response: Authorization = data.data;
      if (data.success) {
        this.authService.setCredential(response);
        this.httpAlertService.success(this.translate.instant("logged_in"));
        this.cartService.storeItemsInDb().then(() => {
          this.loginEmitter.next({ success: true });

          this.router.navigate([this.redirectValidLogin]);
        });
        this.cartService.quantity().subscribe(d => {
          this.cartService.changeQuantity({ count: d.data });
        });
      }
      this.logging = false;
    }, (err) => {
      this.logging = false;
      if (err.error.message === 'account_not_active') {
        this.httpAlertService.error(this.translate.instant(err.error.message));
      } else {
        this.httpAlertService.error(this.translate.instant("login_unathorized"));
      }
    }
    );
  }


  private initLoginForm() {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  get email() {
    return this.loginForm.get("email");
  }
  get password() {
    return this.loginForm.get("password");
  }

}
